import { Dispatch } from "redux";
import { setLoading } from "./global";
import { showMessage } from "utilities/helper";
import RaffleMerchantService from "service/RaffleMerchant";

export const getAllRaffleMerchants =
  (
    page: number = 1,
    search: string = "",
    limit: number = 10,
    filterCity: string = ""
  ) =>
  async (dispatch: Dispatch) => {
    dispatch(setLoading(true));
    dispatch({
      type: "SET_RAFFLE_MERCHANT_CURRENT_PAGE",
      currentPage: page,
    });
    dispatch({
      type: "SET_SEARCH_RAFFLE_MERCHANT",
      searchValue: search,
    });

    try {
      const data = await RaffleMerchantService.getAllRaffleMerchants(
        page,
        search,
        limit,
        filterCity
      );

      dispatch(setLoading(false));
      dispatch({ type: "SET_RAFFLE_MERCHANT", value: data.raffle_merchants });

      dispatch({
        type: "SET_RAFFLE_MERCHANT_PAGE",
        totalPage: !!data.raffle_merchants.length ? data.last_page : 1,
        limitPage: limit,
        lengthPage: !!data.raffle_merchants.length ? data.total_data : 1,
      });
      dispatch({
        type: "SET_RAFFLE_MERCHANT_FILTER_PAGE",
        filterCityPage: filterCity,
      });
    } catch (err: any) {
      dispatch(setLoading(false));
      if (err.request.status !== 401) {
        console.log("error :", err);
        showMessage(
          !err.response
            ? err.message
            : !!err.response?.data?.error
            ? err.response?.data?.error
            : err.response?.data?.message,
          "error"
        );
      }
    }
  };
